import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/privacy/page.tsx");
